/**
 * Decodes a base64 encoded UTF-8 string.
 * @param b base64 encoded message.
 * @returns The message decoded as utf-8
 * @author https://stackoverflow.com/a/30106551/694331
 */
export function decodeUtf8(b: string): string {
	return decodeURIComponent(Array.prototype.map.call(atob(b), function(c:string) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));
}
